<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <IncreaseRequestTable title="Increase Request"></IncreaseRequestTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IncreaseRequestTable from "./Tables/IncreaseRequestTable";
export default {
  name: "IncreaseRequest",
  components: {
    IncreaseRequestTable,
  },
};
</script>
<style></style>
